<div id="face-banding-form" class="flex flex-auto flex-col justify-start items-stretch gap-3">
  <div *ngIf="panelHasButts" class="flex flex-row justify-start items-center mat-body-2 orange-500-fg gap-2">
    <div>
      <mat-icon>warning</mat-icon>
    </div>
    <div i18n>Проверьте правильность нанесения облицовки</div>
  </div>

  <div class="flex flex-auto flex-col justify-center items-stretch gap-3 control-wrapper" cslPerfectScrollbar>
    <button
      data-testid="btnFaceBandingTop"
      i18n
      mat-flat-button
      color="accent"
      [disabled]="!editable"
      (click)="openMaterialBaseDialog('+')"
      >Добавить сверху</button
    >

    <div class="flex flex-col justify-start items-stretch gap-3">
      <ng-container *ngFor="let item of bands">
        <div *ngIf="item.level > 0" class="flex flex-row justify-start items-center gap-3 fuse-card px-4 py-2">
          <ng-container *ngTemplateOutlet="itemContent; context: { item: item }"></ng-container>
        </div>
      </ng-container>

      <div class="flex flex-row justify-start items-center gap-3 fuse-card p-4 accent-100-bg">
        <div class="flex-1">
          {{ mainMaterial.name }}
        </div>
        <div class="h6">
          <ng-container [ngSwitch]="mainMaterial.type">
            <span *ngSwitchCase="0" i18n>Плитный</span>
            <span *ngSwitchCase="1" i18n>Погонный</span>
            <span *ngSwitchDefault></span>
          </ng-container>
        </div>
        <div class="h6">({{ mainMaterial.thickness }}mm)</div>
      </div>

      <ng-container *ngFor="let item of bands">
        <div *ngIf="item.level < 0" class="flex flex-row justify-start items-center gap-3 fuse-card px-4 py-2">
          <ng-container *ngTemplateOutlet="itemContent; context: { item: item }"></ng-container>
        </div>
      </ng-container>

      <ng-template #itemContent let-item="item">
        <div>({{ item.order }}) {{ item.material.name }}</div>
        <div class="h6">
          <ng-container [ngSwitch]="item.material.type">
            <span *ngSwitchCase="0" i18n>Плитный</span>
            <span *ngSwitchCase="1" i18n>Погонный</span>
            <span *ngSwitchDefault></span>
          </ng-container>
        </div>
        <div class="h6">({{ item.material.thickness }}mm)</div>
        <button mat-icon-button (click)="deleteBand(item)">
          <mat-icon>delete</mat-icon>
        </button>
      </ng-template>
    </div>

    <button
      data-testid="btnFaceBandingBottom"
      i18n
      mat-flat-button
      color="accent"
      [disabled]="!editable"
      (click)="openMaterialBaseDialog('-')"
      >Добавить снизу</button
    >
  </div>
</div>
